import React from 'react';
import styles from './InventorySearch.module.css';

interface InventorySearchProps {
  value: string;
  onChange: (value: string) => void;
}

export const InventorySearch: React.FC<InventorySearchProps> = ({ value, onChange }) => {
  return (
    <div className={styles.searchWrapper}>
      <svg className={styles.searchIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="8" />
        <path d="M21 21l-4.35-4.35" />
      </svg>
      <input
        type="text"
        className={styles.searchInput}
        placeholder="Search by SKU, product name, or category..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};
